




















































































































































































import { Component, Mixins, Prop } from "vue-property-decorator";
import { GlobalMixin } from "@/mixins/global";
import { HomeInfo } from "@/interfaces/general";
import { mapMutations } from "vuex";

@Component({
  components: {},
  computed: {},
  methods: {
    ...mapMutations("module", ["setModule"])
  }
})
export default class HomeContent extends Mixins(GlobalMixin) {
  setModule!: (data: string) => void;
  @Prop({ type: Array, required: true }) homeContent!: HomeInfo[];
  @Prop({ type: String }) title!: string;
  @Prop({ type: Boolean }) devices!: boolean;

  redirect(module: string): void {
    let select: string = "";

    if (module === "Value Chain Reconciliation") {
      select = "Reconciliation";
    } else if (module === "Open Pit Mine Data Management") {
      select = "Mining Production";
    } else if (module === "Continuos Improvement") {
      select = "Continuous Improvement";
    }

    this.setModule(select);
    this.$router.push({ name: "modules" });
  }
}
